import React, { useState, useEffect } from 'react';
import useSound from 'use-sound';
import whiteNoise from './white-noise.mp3'; // Import the white noise sound file
import '/Users/ali/educare/src/ADHDQuestions.css';
import { runPrediction } from '/Users/ali/educare/src/predictor.js';

const ADHDQuestions = () => {
  const [question1, setQuestion1] = useState(null);
  const [question2, setQuestion2] = useState(null);
  const [question3, setQuestion3] = useState(null);
  const [question4, setQuestion4] = useState(null);
  const [question5, setQuestion5] = useState(null);
  const [question6, setQuestion6] = useState(null);
  const [result, setResult] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [dimPage, setDimPage] = useState(false);
  const [responseVisible, setResponseVisible] = useState(false);

  const [playWhiteNoise, { stop }] = useSound(whiteNoise, { volume: 0.5 });

  const handleSubmit = async () => {
    const score = parseInt(question1) + parseInt(question2) + parseInt(question3) + parseInt(question4) + parseInt(question5) + parseInt(question6);
    setResult(score);

    // Call runPrediction with the required input data
    const interactionData = {
      userAnswer: score,
      correctAnswer: 24, // Replace this value with the correct answer if it's different
    };
    const bestContentType = await runPrediction(interactionData);

    // Show the best learning style based on the bestContentType
    switch (bestContentType) {
      case 0:
        alert("You learn best with text content.");
        break;
      case 1:
        alert("You learn best with audio content.");
        break;
      case 2:
        alert("You learn best with video content.");
        break;
      default:
        alert("Couldn't determine the best content type.");
        break;
    }
  };

  const handleNext = () => {
    if (currentQuestion < 6) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      handleSubmit();
    }
  };

  const handleStopWhiteNoise = () => {
    stop();
  };

  const handlePlayWhiteNoise = () => {
    playWhiteNoise();
  };

  useEffect(() => {
    if (result >= 10) {
      setDimPage(true);
      setResponseVisible(true);
    }
  }, [result]);
  const renderRadioButtons = (questionNumber, setQuestion) => (
    <div className="radio-buttons">
      <div className="radio-option">
        <input type="radio" id={`${questionNumber}-1`} name={questionNumber} value="0" onChange={() => setQuestion(0)} />
        <label htmlFor={`${questionNumber}-1`}>Never</label>
      </div>

      <div className="radio-option">
        <input type="radio" id={`${questionNumber}-2`} name={questionNumber} value="1" onChange={() => setQuestion(1)} />
        <label htmlFor={`${questionNumber}-2`}>Rarely</label>
      </div>

      <div className="radio-option">
        <input type="radio" id={`${questionNumber}-3`} name={questionNumber} value="2" onChange={() => setQuestion(2)} />
        <label htmlFor={`${questionNumber}-3`}>Sometimes</label>
      </div>

      <div className="radio-option">
        <input type="radio" id={`${questionNumber}-4`} name={questionNumber} value="3" onChange={() => setQuestion(3)} />
        <label htmlFor={`${questionNumber}-4`}>Often</label>
      </div>

      <div className="radio-option">
        <input type="radio" id={`${questionNumber}-5`} name={questionNumber} value="4" onChange={() => setQuestion(4)} />
        <label htmlFor={`${questionNumber}-5`}>Very often</label>
      </div>
    </div>
  );

  return (
    <>
      {dimPage && <div className="overlay" onClick={() => { setDimPage(false); setResponseVisible(false); }}></div>}

      {responseVisible && (
          <div className="response-content">
            <h2>Result</h2>
         
            <p>
              This is a self-assessment tool, not a diagnostic tool. If you are concerned about your score, please consult a healthcare professional for a thorough evaluation. 
            </p>
            <button onClick={() => { setDimPage(false); setResponseVisible(false); }}>Close</button>
          </div>
        
      )}

      <div className="adhd-questions">
        <h1>Stimuli Questions</h1>
        <p>Answer the following questions about your behavior and habits:</p>

        {currentQuestion === 1 && (
          <div className="question">
            <h2>Question 1</h2>
            <p>How often do you have trouble wrapping up the final details of a project, once the challenging parts have been done?</p>
            {renderRadioButtons("question1", setQuestion1)}
          </div>
        )}

        {currentQuestion === 2 && (
          <div className="question">
            <h2>Question 2</h2>
            <p>How often do you have difficulty getting things in order when you have to do a task that requires organization?</p>
            {renderRadioButtons("question2", setQuestion2)}
          </div>
        )}

        {currentQuestion === 3 && (
          <div className="question">
            <h2>Question 3</h2>
            <p>How often do you have problems remembering appointments or obligations?</p>
            {renderRadioButtons("question3", setQuestion3)}
          </div>
        )}

        {currentQuestion === 4 && (
          <div className="question">
            <h2>Question 4</h2>
            <p>When you have a task that requires a lot of thought, how often do you avoid or delay getting started?</p>
            {renderRadioButtons("question4", setQuestion4)}
          </div>
        )}

        {currentQuestion === 5 && (
          <div className="question">
            <h2>Question 5</h2>
            <p>How often do you fidget or squirm with your hands or feet when you have to sit down for a long time?</p>
            {renderRadioButtons("question5", setQuestion5)}
          </div>
        )}

        {currentQuestion === 6 && (
          <div className="question">
            <h2>Question 6</h2>
            <p>How often do you feel overly active and compelled to do things, like you were driven by a motor?</p>
            {renderRadioButtons("question6", setQuestion6)}
          </div>
        )}

<div className="buttons">
          {currentQuestion > 1 && <button onClick={() => setCurrentQuestion(currentQuestion - 1)}>Previous</button>}
          <button onClick={handleNext}>{currentQuestion === 6 ? 'Submit' : 'Next'}</button>
        </div>
        {result >= 10 && (
          <div className="white-noise-button">
            <button onClick={handlePlayWhiteNoise}>Play White Noise</button>
            <button onClick={handleStopWhiteNoise}>Stop White Noise</button>
          </div>
        )}
      </div>
    </>
  );
};

export default ADHDQuestions;

